import type { Rol } from './types';

/** SPEC §2 – wat mag een rol. Gebruikt door API (afdwingen) en web (tonen/verbergen). */
export type Recht =
  | 'projecten.lezen'
  | 'projecten.schrijven'
  | 'projecten.nummer'
  | 'pakketten.schrijven'
  | 'taken.lezen'
  | 'taken.aanmaken'
  | 'taken.plannen'
  | 'rooster'
  | 'verlof'
  | 'templates'
  | 'beheer'
  | 'eigen-taken'
  | 'agile.plannen'
  /** SPEC §11.6: uren van anderen zien en corrigeren */
  | 'uren.alle'
  /** SPEC §11.6: weekstaten goedkeuren */
  | 'uren.goedkeuren';

const MATRIX: Record<Rol, Recht[]> = {
  BEHEERDER: ['projecten.lezen', 'projecten.schrijven', 'projecten.nummer', 'pakketten.schrijven', 'taken.lezen', 'taken.aanmaken', 'taken.plannen', 'rooster', 'verlof', 'templates', 'beheer', 'eigen-taken', 'agile.plannen', 'uren.alle', 'uren.goedkeuren'],
  PLANNER: ['projecten.lezen', 'projecten.schrijven', 'pakketten.schrijven', 'taken.lezen', 'taken.aanmaken', 'taken.plannen', 'rooster', 'verlof', 'templates', 'eigen-taken', 'agile.plannen', 'uren.alle'],
  PROJECTMANAGER: ['projecten.lezen', 'projecten.schrijven', 'pakketten.schrijven', 'taken.aanmaken', 'agile.plannen', 'uren.alle', 'uren.goedkeuren'],
  ENGINEER: ['eigen-taken'],
};

export function mag(rol: Rol | null | undefined, recht: Recht): boolean {
  return !!rol && MATRIX[rol].includes(recht);
}

export const ROL_LABEL: Record<Rol, string> = {
  BEHEERDER: 'Beheerder',
  PLANNER: 'Planner',
  PROJECTMANAGER: 'Projectmanager',
  ENGINEER: 'Engineer',
};
